import React from "react";
import useEngagementIds from "hooks/engagement/useEngagementIds";
import useEngagementClient from "hooks/engagement/useEngagementClient";

const useBookViewTracking = (bookId, { enabled = true } = {}) => {
	const { al_sid, al_vid } = useEngagementIds();
	const { send } = useEngagementClient(bookId);

	React.useEffect(() => {
		if (!enabled || !bookId) return;
		try {
			const dedupeKey = `eng_view_${bookId}_${al_sid}`;
			if (!sessionStorage.getItem(dedupeKey)) {
				send({ event: "view", al_sid, al_vid });
				sessionStorage.setItem(dedupeKey, "1");
			}
		} catch (_) {}
	}, [enabled, bookId, al_sid, al_vid, send]);
};

export default useBookViewTracking;
